var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3963 17.9292V17.9792H11.4463H12.5605H12.6105V17.9292V16.7505C14.2853 16.5643 15.468 15.5293 15.468 14.019V14.0054C15.468 13.3492 15.23 12.7994 14.767 12.3626C14.3054 11.9271 13.6227 11.6062 12.7359 11.4L11.8337 11.1881L11.8334 11.1881C11.3144 11.0694 10.9263 10.8991 10.6689 10.6864C10.4131 10.475 10.2863 10.2219 10.2863 9.93115V9.91748C10.2863 9.54431 10.4492 9.23788 10.7451 9.02313C11.0425 8.80728 11.4772 8.68232 12.0205 8.68232C12.5353 8.68232 12.9564 8.81353 13.2577 9.03974C13.5583 9.26543 13.7427 9.58768 13.7823 9.97723L13.7891 10.0455L13.7936 10.0905H13.8389H15.2676H15.321L15.3175 10.0372L15.3106 9.93482C15.3106 9.93482 15.3106 9.93481 15.3106 9.93481C15.2275 8.62582 14.1702 7.60595 12.6105 7.39884V6.19189V6.14189H12.5605H11.4463H11.3963V6.19189V7.39879C9.82347 7.60534 8.74395 8.60639 8.74395 10.02V10.0337C8.74395 10.6829 8.98179 11.2289 9.41769 11.6578C9.85258 12.0857 10.4823 12.395 11.264 12.5775C11.264 12.5775 11.264 12.5775 11.264 12.5775L12.2002 12.7962C12.2002 12.7962 12.2003 12.7962 12.2003 12.7962C12.8062 12.9426 13.237 13.1199 13.5157 13.3397C13.7916 13.5573 13.9187 13.8166 13.9187 14.1353V14.1489C13.9187 14.557 13.7502 14.88 13.4381 15.1029C13.124 15.3271 12.6604 15.4524 12.0684 15.4524C11.4805 15.4524 11.0041 15.3223 10.6635 15.0911C10.324 14.8606 10.1167 14.5282 10.0672 14.1156L10.0672 14.1154L10.0604 14.0607L10.0549 14.0169H10.0107H8.56836H8.51437L8.51851 14.0707L8.52534 14.1596L8.52535 14.1596C8.63612 15.5859 9.77697 16.5379 11.3963 16.7363V17.9292Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.9995,
    r: 8,
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.56b958e52b55ff7a403185196bd57509.svg";
export { ForwardRef as ReactComponent };